<template>
  <section v-if="group && group.id && getComponentName()" class="user-select-none">
    <component
      :is="getComponentName()"
      :action-link-text="actionLinkText"
      :groups="[group]"
      :hide-header="true"
      :is-click-to-action-item="isClickToActionItem"
      :pet-essentials-type="isPetEssentialsType()"
      :redirect-path="redirectPath"
      :style="{ order }"
      v-on="$listeners"
    />
  </section>
</template>

<script>
import CollarLeashProductGroup from '../components/collar&leash/CollarLeashProductGroup';
import ProductGroup from '../components/ProductGroup';

export default {
  name: 'ProductCarousel',
  components: { ProductGroup, CollarLeashProductGroup },
  props: {
    group: {
      type: Object,
      required: true,
    },
    actionLinkText: {
      type: String,
      required: true,
      default: null,
    },
    order: {
      type: [Number, String],
      required: false,
      default: null,
    },
    redirectPath: {
      type: String,
      required: false,
      default: null,
    },
    isClickToActionItem: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  methods: {
    getComponentName() {
      switch (this.group.productType) {
        case 'G':
        case 'T':
        case 'X':
          return 'ProductGroup';
        case 'A':
        case 'S':
          return 'CollarLeashProductGroup';
        default:
          return null;
      }
    },
    isPetEssentialsType() {
      return this.group?.productType === 'X';
    },
  },
};
</script>

<style lang="scss" scoped></style>
